import type React from 'react'
import type { JSX } from 'react'
import type { IMultiColumnProps } from '../../MultiColumns'
import type { IMCItemTitleWithLabels } from '../MultiColumnsItem/MCItemTitleWithLabels'

import { MCItemTitleWithLabels } from '../MultiColumnsItem/MCItemTitleWithLabels'
import { MCTitleWithLabelsTemplate } from './MCTitleWithLabels.styled'

export interface IMCTitleWithLabels extends Omit<
  IMCItemTitleWithLabels & IMultiColumnProps,
  'children'
> {
  children?: React.ReactNode
  title: string
  dataTestId?: string
}

export const MCTitleWithLabels = ({
  labels,
  contentLabels,
  statusBadge,
  statusBadgeTone,
  statusBadgeFirst,
  ageRatingLabel,
  paid,
  rented,
  purchaseTitle,
  title,
  titleMaxLines,
  subtitle,
  children: _unused,
  width = 100,
  columnValue = 2,
  dataTestId,
  quality,
  dolbyAtmos,
  verticalVideo,
  ...rest
}: IMCTitleWithLabels): JSX.Element => {
  return (
    <MCTitleWithLabelsTemplate
      columnValue={columnValue}
      width={width}
      {...rest}
    >
      <MCItemTitleWithLabels
        title={title}
        titleMaxLines={titleMaxLines}
        subtitle={subtitle}
        labels={labels}
        contentLabels={contentLabels}
        statusBadge={statusBadge}
        statusBadgeTone={statusBadgeTone}
        statusBadgeFirst={statusBadgeFirst}
        ageRatingLabel={ageRatingLabel}
        paid={paid}
        rented={rented}
        purchaseTitle={purchaseTitle}
        dataTestId={dataTestId}
        quality={quality}
        dolbyAtmos={dolbyAtmos}
        verticalVideo={verticalVideo}
      />
    </MCTitleWithLabelsTemplate>
  )
}
